
<template>
<div id="app" class="app-container">
    <router-view v-slot="{ Component }">
        <keep-alive>
        <component :is="Component" :key="$route.fullPath" />
        </keep-alive>
    </router-view>
</div>
</template>


<script>
export default {
    name: 'App',
    // 组件的逻辑部分
};
</script>

<style>
html,
body {
    background-color: #F6EDE6 !important;
    /* 香槟色背景 */
    margin: 0;
    /* 去除页面默认的边距 */
    height: 100%;
    /* 设置高度为100%，确保背景色铺满整个视口 */
    /* padding: 0; */
}

/* * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
} */



.app-container {
    margin: 0;
    /* 去除页面默认的边距 */
}
</style>
